import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/Shield-Done.png'


const _hoisted_1 = { class: "background-grey-lighten-5 px-5 py-5 mb-4 rounded-lg" }
const _hoisted_2 = { class: "flex flex-wrap lg:flex-nowrap w-full justify-between" }
const _hoisted_3 = { class: "py-2 w-full lg:w-auto mr-2" }
const _hoisted_4 = { class: "font-bold text-2xl break-all" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 0,
  class: "color-primary"
}
const _hoisted_7 = { class: "font-semibold mb-1 color-blue-grey" }
const _hoisted_8 = { class: "font-semibold mb-1 color-blue-grey" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col  items-center"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Ke Manifest Jadwal")
const _hoisted_11 = { class: "lg:w-auto w-full py-2 flex items-center" }
const _hoisted_12 = { class: "mr-2" }
const _hoisted_13 = { class: "font-semibold lg:text-base md:text-base text-sm px-2 rounded-lg background-blue-grey-lighten-5 border-radius-blue-grey-darken-1 color-blue-grey" }
const _hoisted_14 = { class: "grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2" }
const _hoisted_15 = { class: "lg:mb-0 md:mb-0 mb-4" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-1 color-blue-grey" }, "Pengirim", -1)
const _hoisted_17 = { class: "font-semibold mb-1 break-all" }
const _hoisted_18 = { class: "font-semibold mb-1 break-all" }
const _hoisted_19 = { class: "lg:hidden md:hidden block" }
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-2 color-blue-grey" }, "Diskon Pelanggan : ", -1)
const _hoisted_21 = { class: "color-red font-semibold" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-1 color-blue-grey" }, "Penerima", -1)
const _hoisted_24 = { class: "font-semibold mb-1 break-all" }
const _hoisted_25 = { class: "font-semibold mb-1 break-all" }
const _hoisted_26 = { class: "lg:hidden md:hidden block" }
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-2 color-blue-grey" }, "Total Biaya Tambahan : ", -1)
const _hoisted_28 = { class: "color-red font-semibold" }
const _hoisted_29 = { class: "grid-cols-2 gap-2 lg:grid md:grid hidden" }
const _hoisted_30 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-4 color-blue-grey" }, "Total Biaya Tambahan : ", -1)
const _hoisted_31 = { class: "color-red font-semibold" }
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-4 color-blue-grey" }, "Diskon Pelanggan : ", -1)
const _hoisted_33 = { class: "color-red font-semibold" }
const _hoisted_34 = { class: "grid gap-4 grid-cols-1 sm:grid-cols-2 mb-4 background-blue-grey-lighten-5 rounded-lg" }
const _hoisted_35 = { class: " rounded-lg px-5 py-3" }
const _hoisted_36 = { class: "flex font-bold text-base mb-4" }
const _hoisted_37 = /*#__PURE__*/_createVNode("img", {
  alt: "total pendapatan",
  src: _imports_0,
  class: "lg:w-6 md:w-6 w-3 mr-2"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Asuransi ")
const _hoisted_39 = { class: "color-blue-grey ml-1" }
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = { class: "mb-2 flex-auto" }
const _hoisted_42 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Harga Barang", -1)
const _hoisted_43 = { class: "flex" }
const _hoisted_44 = { class: "mb-2 flex-auto" }
const _hoisted_45 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "No Asuransi", -1)
const _hoisted_46 = { class: "mb-2 flex-auto" }
const _hoisted_47 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Total Asuransi", -1)
const _hoisted_48 = { class: " rounded-lg px-5 py-3 border-l-2 border-dashed border-gray-400" }
const _hoisted_49 = { class: "flex" }
const _hoisted_50 = { class: "mb-2 flex-auto" }
const _hoisted_51 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey mb-1" }, "Ket. Pengakuan Barang", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("div", {
  class: "flex items-center justify-between mx-2 pt-2 pb-4",
  style: {"border-bottom":"1px solid #ECEFF1"}
}, [
  /*#__PURE__*/_createVNode("p", null, "Biaya Pengembalian"),
  /*#__PURE__*/_createVNode("p", { class: "font-normal color-blue-grey text-sm" }, "*Sudah termasuk biaya tambahan dan diskon")
], -1)
const _hoisted_53 = { class: "flex items-center justify-between mx-2 pt-4 pb-2 " }
const _hoisted_54 = /*#__PURE__*/_createVNode("p", { class: "font-semibold color-blue-grey" }, "Yang Harus Dikembalikan ", -1)
const _hoisted_55 = { class: "color-red font-semibold" }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "flex items-center p-4 w-full justify-between" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-normal text-lg" }, "Barang Pada Resi")
], -1)
const _hoisted_57 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_58 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_59 = { class: "font-semibold text-black px-4 h-14 flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("p", _hoisted_4, "#" + _toDisplayString(_ctx.data.Resi), 1),
          _createVNode("span", _hoisted_5, [
            (_ctx.data.AgenAsalNama && _ctx.data.AgenTujuanNama)
              ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.data.AgenAsalNama) + " - " + _toDisplayString(_ctx.data.AgenTujuanNama), 1))
              : _createCommentVNode("", true),
            (_ctx.data.TransJadwalHdKodeJadwal)
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("p", _hoisted_7, _toDisplayString(_ctx.data.TransJadwalHdKodeJadwal), 1),
                  _createVNode("p", _hoisted_8, "Tanggal Berangkat : " + _toDisplayString(_ctx.moment(_ctx.data.TransJadwalHdTanggalAktif).format('DD MMM YYYY')), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.data.StatusPengirimanStatus)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              (_ctx.data.StatusPengirimanStatus === 'Diproses')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "px-2 inline-block rounded-md font-semibold text-base",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emit('openManifestJadwal')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("p", {
                    class: "px-2 inline-block rounded-md font-semibold text-base break-all",
                    style: {
            backgroundColor: _ctx.data.StatusPengirimanAttribute1 ?? 'black',
            color: _ctx.data.StatusPengirimanAttribute2 ?? 'white',
            border: `1px solid ${_ctx.data.StatusPengirimanAttribute2 ?? 'white'}`
          }
                  }, _toDisplayString(_ctx.data.StatusPengirimanStatus), 5)
                ]),
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.data.TipePengiriman), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode("p", _hoisted_17, _toDisplayString(_ctx.data.NamaPengirim), 1),
          _createVNode("p", _hoisted_18, _toDisplayString(`${_ctx.data.AlamatPengirim} (${_ctx.data.HpPengirim})`), 1),
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode("p", _hoisted_21, "Rp. " + _toDisplayString(new Number(_ctx.data.Diskon).toLocaleString("id-ID")), 1)
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode("p", _hoisted_24, _toDisplayString(_ctx.data.NamaPenerima), 1),
          _createVNode("p", _hoisted_25, _toDisplayString(`${_ctx.data.AlamatPenerima} (${_ctx.data.HpPenerima})`), 1),
          _createVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode("p", _hoisted_28, "Rp. " + _toDisplayString(new Number(_ctx.data.BiayaTambahan).toLocaleString("id-ID")), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_29, [
        _createVNode("div", null, [
          _hoisted_30,
          _createVNode("p", _hoisted_31, "Rp. " + _toDisplayString(new Number(_ctx.data.BiayaTambahan).toLocaleString("id-ID")), 1)
        ]),
        _createVNode("div", null, [
          _hoisted_32,
          _createVNode("p", _hoisted_33, "Rp. " + _toDisplayString(new Number(_ctx.data.Diskon).toLocaleString("id-ID")), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_34, [
      _createVNode("div", _hoisted_35, [
        _createVNode("p", _hoisted_36, [
          _hoisted_37,
          _hoisted_38,
          _createVNode("span", _hoisted_39, _toDisplayString(_ctx.dataAnsuransi.nama ?? '-'), 1)
        ]),
        _createVNode("div", _hoisted_40, [
          _createVNode("div", _hoisted_41, [
            _hoisted_42,
            _createVNode("p", null, "Rp. " + _toDisplayString(new Number(_ctx.data.PengakuanNilaiBarang ?? 0).toLocaleString("id-ID")), 1)
          ])
        ]),
        _createVNode("div", _hoisted_43, [
          _createVNode("div", _hoisted_44, [
            _hoisted_45,
            _createVNode("p", null, _toDisplayString(_ctx.data?.NoReferensiAsuransi ?? '-'), 1)
          ]),
          _createVNode("div", _hoisted_46, [
            _hoisted_47,
            _createVNode("p", null, "Rp. " + _toDisplayString(new Number(_ctx.data.TotalAsuransi ?? 0).toLocaleString("id-ID")), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_48, [
        _createVNode("div", _hoisted_49, [
          _createVNode("div", _hoisted_50, [
            _hoisted_51,
            _createVNode("p", null, _toDisplayString(_ctx.data.KeteranganBiayaTambahan ?? '-'), 1)
          ])
        ])
      ])
    ]),
    (_ctx.onRefund)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "card-no-shadow card-p-0 mb-5 px-4 py-3"
        }, {
          content: _withCtx(() => [
            _hoisted_52,
            _createVNode("div", _hoisted_53, [
              _hoisted_54,
              _createVNode("p", _hoisted_55, "Rp. " + _toDisplayString(new Number(_ctx.data.GrandTotal).toLocaleString("id-ID")), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.data.TransPengirimanDetails)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 1,
          class: "card-no-shadow card-p-0 mb-5"
        }, {
          content: _withCtx(() => [
            _hoisted_56,
            _createVNode(_component_DataTable, {
              value: _ctx.data.TransPengirimanDetails,
              class: "table-og body-td-x-0",
              responsiveLayout: "scroll"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, { header: "Satuan" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", _hoisted_57, _toDisplayString(slotProps.data.Berat), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Kategori Barang" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", _hoisted_58, _toDisplayString(slotProps.data.KategoriBarangNama), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Biaya Barang" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", _hoisted_59, "Rp. " + _toDisplayString(new
            Number(slotProps.data.TotalHarga).toLocaleString("id-ID")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}